// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountSiteRegistrationDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountSiteRegistrationDefaultResponse.attributeTypeMap;
    }
}
SiteAccountSiteRegistrationDefaultResponse.discriminator = undefined;
SiteAccountSiteRegistrationDefaultResponse.additionalProperties = false;
SiteAccountSiteRegistrationDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ISiteRegistrationData"
    },
];
//# sourceMappingURL=siteAccountSiteRegistrationDefaultResponse.js.map